import copy from "copy-to-clipboard";

export default {
  name: "CopyToClipboard",
  components: {},
  props: ["text"],
  computed: {},
  data() {
    return {};
  },

  mounted() {},
  methods: {
    onClick() {
      const result = copy(this.text);

      if (result) {
        this.$message.success(this.$t("Copy_Success"));
      }
    },
  },

  render() {
    return <span onClick={this.onClick}>{this.$slots.default}</span>;
  },
};
